/* 
*  Created by SGiri 07/12/2018
*/

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../material/material.module";
import { CognosSearchComponent } from "~cognos/cognos-search/cognos-search.component";
import { AgGridModule } from "ag-grid-angular";
import { CognosService } from "~cognos/service/cognos.service";

@NgModule({
    declarations: [
        CognosSearchComponent
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        MaterialModule,
        AgGridModule.withComponents([]),
    ],
    entryComponents: [],
    providers: [
        CognosService
    ],
})
export class CognosModule {
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/cognos/cognos.module.ts